import React from 'react';

const ListToken = () => {
    return (
        <div>
            
        </div>
    );
};

export default ListToken;